import ApiService from '@/services/ApiService'
import TranslationService from '@/services/TranslationService'
import store from '@/store/store'
import router from '@/router/index'
import swal from 'sweetalert'

const api = new ApiService()

export default {
    /**
     * Registers a new user.
     * @param {*} user a new user
     */
    async register (user) {
        let loginRoute = router.options.routes.find((route) => { return route.name === 'login' }).path
        let result

        if (user.UserName.length > 2) {
            // setting the ConfirmURL here because we need access to the routes to determine the path
            user.ConfirmURL = location.origin + `/#${loginRoute}?code=`
            let response = await api.post('public/registerUser', user)
            if (response === 'OK') {
                result = {
                    Message: TranslationService.get('registrationSuccess'),
                    ExceptionLevel: 'SUCCESS'
                }
            } else if (response.Message) {
                result = {
                    Message: TranslationService.get(response.Message),
                    ExceptionLevel: 'WARNING'
                }
            } else if (response.Error.Message) { // === 'No ConfirmPassword given'
                result = {
                    Message: TranslationService.get(response.Error.Message),
                    ExceptionLevel: 'WARNING'
                }
            } else {
                result = {
                    Message: TranslationService.get('UnknownError'),
                    ExceptionLevel: 'DANGER'
                }
            }
        } else {
            result = {
                Message: TranslationService.get('InvallidModelState'),
                ExceptionLevel: 'WARNING'
            }
        }
        return result
    },

    /**
     * Log the user in by its basic credentials.
     * Sets the new token as autorization token.
     * @param {*} user a user with basic credentials
     */
    async login (basicAuth) {
        // let result = await Api(user.Username, user.Password).get('public/registerUser')
        let result = await api.get('public/registerUser', null, basicAuth)
        if (result.UserName) {
            store.dispatch('setToken', 'Bearer ' + result.Token.Acces_token)
            store.dispatch('setUser', result)
            result = {
                Message: TranslationService.get('InlogSucces'),
                ExceptionLevel: 'SUCCESS'
            }
        } else if (result.ExceptionLevel) {
            result.Message = TranslationService.get(result.Message)
        } else {
            throw new Error('UnknownResult')
        }
        return result
    },

    async confirmUser (code) {
        let result = await api.post(`public/registerUser/confirmuser?code=${code}`)
        if (result.ExceptionLevel) {
            swal('', result.Message, result.ExceptionLevel.toLowerCase())
        }
        if (result === 'Succes_RegistrationConfirm') {
            swal('', 'Je account is succesvol bevestigd, je kunt nu inloggen.', 'success')
        //     this.message = 'Je account is succesvol bevestigd, je kunt nu inloggen.'
        //     this.alert = 'alert alert-success'
        // } else if (result === 'Exception_RegistrationConfirmWrongInput') {
        //     this.errorMessage = 'Het bevestigen van je account is mislukt! Neem contact met ons op om je account te laten bevestigen of probeer het later nog eens.'
        //     this.alert = 'alert alert-warning'
        }
        return result
    },

    /**
     * Logs the current user out.
     */
    async logout (reason = 'Je bent uitgelogd.', icon = 'success') {
        store.dispatch('setUser', null)
        swal('', reason, icon)
    },

    /**
     * Gets the current user.
     */
    getUser () {
        let user = store.state.user
        return user
    },

    /**
     * Checks if the user is logged in.
     */
    isUserLoggedIn () {
        return store.state.token !== null && store.state.token !== ''
    },

    async lostPassword (email) {
        let resetPasswordRoute = router.options.routes.find((route) => { return route.name === 'resetpassword' }).path
        let body = {
            Email: email,
            URL: location.origin + `/#${resetPasswordRoute}?code=<code>`,
            LanguageID: 'NL'
        }
        let result = await api.post('public/registerUser/lostpassword', body)
        return result
    },

    async resetPassword (body) {
        let result = await api.post('public/registerUser/resetpassword', body)
        return result
    }
}



// WEBPACK FOOTER //
// ./src/services/AuthorizationService.js